import { ValidationControlHelper } from "./ValidationControlHelper";

export class VisibilityControlHelper {

  private static helpers = {
    isOfAge: (birthDate: Date, age: number) => {
      if(!birthDate) {
        return false;
      }

      const ageThresholdDate = new Date(
          birthDate.getFullYear() + age,
          birthDate.getMonth(),
          birthDate.getDate(),
          birthDate.getHours(),
          birthDate.getMinutes(),
          birthDate.getSeconds(),
          birthDate.getMilliseconds()
      );

      return new Date() >= ageThresholdDate;
    }
  };

  public static isFieldVisible = (field: Field, formData: any, formErrors: any, fields: Field[], handleNewFormData: any, 
    customVisibleConditions: (field: Field, formData: any, formErrors: any, fields: Field[], handleNewFormData: any, isVisible: boolean) => boolean) : boolean => {
   
    let isVisible = true;

    if (field.visibilityconditiondata) {
      const condition = field.visibilityconditiondata.VisibilityConditionConfiguration;
      if(condition) {
        isVisible = false;
        switch (condition.Identifier) {
          case "TrueLime.ExpressionVisibilityCondition":
            isVisible = VisibilityControlHelper.evaluateExpression(condition.VisibilityCondition.Expression, formData);
            break;
          case "Kentico.AnotherStringField":
            isVisible = VisibilityControlHelper.evaluateAnotherStringField(field, condition.VisibilityCondition, formData, formErrors, fields, handleNewFormData, customVisibleConditions);
            break;
          case "Kentico.AnotherBoolField":
            isVisible = VisibilityControlHelper.evaluateAnotherBoolField(field, condition.VisibilityCondition, formData, formErrors, fields, handleNewFormData, customVisibleConditions);
            break;
          default:
            break;
        }
      }
    }

    isVisible = customVisibleConditions(field, formData, formErrors, fields, handleNewFormData, isVisible);

    return isVisible;
  }

  public static evaluateExpression(expression: string, formData: any, helpers: Record<string, (...args: any[]) => any> = {}): boolean {
    const parsedExpression = expression.replace(/Fields\["(\w+)"\]/g, (match, fieldName) => {
      if (formData.hasOwnProperty(fieldName)) {
        const field = formData[fieldName];
        if (field && typeof field === 'object' && 'value' in field) {
          const value = field.value;

          if(!value) {
            return 'null';
          }

          // Check if the value is a date
          if (!isNaN(Date.parse(value))) {
            return `new Date("${value}")`; // Replace with a Date object
          }
          return `"${value}"`;
        }
        return `"${field}"`;
      } else {
        return 'undefined';
      }
    });

    try {
      // Create a dynamic function that includes the helpers
      const helperNames = Object.keys(this.helpers).join(", ");
      const helperValues = Object.keys(this.helpers).map(key => this.helpers[key])

      const result = new Function(helperNames, `return ${parsedExpression};`)(...helperValues);
      return !!result; // Ensure the result is a boolean
    } catch (error) {
      console.error("Error evaluating expression:", error);
      return false;
    }
  }

  public static evaluateAnotherBoolField(field: any, condition: any, formData: any, formErrors: any, fields: Field[], handleNewFormData: any,
    customVisibleConditions: (field: Field, formData: any, formErrors: any, fields: Field[], handleNewFormData: any, isVisible: boolean) => boolean
  ): boolean {
    let isVisible = false;
    const dependeeField = fields.find(f => f["@guid"] === condition.DependeeFieldGuid);
    if(dependeeField) {
      if(VisibilityControlHelper.isFieldVisible(dependeeField, formData, formErrors, fields, handleNewFormData, customVisibleConditions)) {
        const dependeeEntry: FormDataEntry = formData[dependeeField["@column"]] || { value: dependeeField.properties.defaultvalue, focus: undefined, touched: undefined }; 
        if (condition.ExpectedValue === 'IsTrue') {
          isVisible = ValidationControlHelper.valueIsWhatBoolean(dependeeEntry?.value) == true;
        }
        if (condition.ExpectedValue === 'IsFalse') {
          isVisible = ValidationControlHelper.valueIsWhatBoolean(dependeeEntry?.value) == false;
        }
      }
      else {
        isVisible = false;
      }
    }
    return isVisible;
  }

  public static evaluateAnotherStringField(field: any, condition: any, formData: any, formErrors: any, fields: Field[], handleNewFormData: any,
    customVisibleConditions: (field: Field, formData: any, formErrors: any, fields: Field[], handleNewFormData: any, isVisible: boolean) => boolean
  ): boolean {
    let isVisible = false;
    const dependeeField = fields.find(f => f["@guid"] === condition.DependeeFieldGuid);
    if(dependeeField) {
      if(VisibilityControlHelper.isFieldVisible(dependeeField, formData, formErrors, fields, handleNewFormData, customVisibleConditions)) {
        const dependeeEntry: FormDataEntry = formData[dependeeField["@column"]]  || { value: dependeeField.properties.defaultvalue, focus: undefined, touched: undefined }; 
        if (condition.ComparisonType === 'Equal') {
          if(condition.CompareToValue == 'isvisible') {
            return true;
          }
          isVisible = dependeeEntry.value === condition.CompareToValue;
          if(!isVisible) {
            delete formData[field["@column"]];
            delete formErrors[field["@column"]];
          }
        }
        if (dependeeEntry !== undefined && (condition.ComparisonType === 'NotEqual')) {
          isVisible = dependeeEntry.value !== undefined && dependeeEntry.value !== condition.CompareToValue;
          if(!isVisible) {
            delete formData[field["@column"]];
            delete formErrors[field["@column"]];
          }
        }
      }
      else {
        isVisible = false;
      }
    }
    return isVisible;
  }
}

